import React, { FunctionComponent } from "react";
import styles from "./Gallery.module.scss";
import GalleryBlockProps from "./GalleryProps.interface";

import Image from "./components/Image/Image";
import Video from "./components/Video/Video";

import combineClasses from "helpers/combine-classes";
import getWrapperClasses from "blocks/helpers/getWrapperClasses";
import useWrapperStyles from "blocks/hooks/useWrapperStyles";
import BackgroundMedia from "components/BackgroundMedia/BackgroundMedia";
import useSplitBackground from "blocks/hooks/useSplitBackground";
import useAnchor from "blocks/hooks/useAnchor";

const Gallery: FunctionComponent<GalleryBlockProps> = (props): JSX.Element => {
    const wrapperClasses = getWrapperClasses(props.settings);
    const wrapperStyles = useWrapperStyles(props.settings);

    const identifier = useAnchor(props.settings.anchorMenuLabel);
    const { splitClasses, splitStyles } = useSplitBackground(props);

    const listSizeClass = props.settings.listSize ? styles[props.settings.listSize] : undefined;
    const spacingBetweenClass = props.settings.spacingBetween ? styles[`gap_${props.settings.spacingBetween}`] : undefined;
    const hasOverflowClass = props.content.gallery?.[0] && props.content.gallery.length > 5 ? styles.has_overflow : styles.has_few;

    return (
        <section className={combineClasses(styles.wrapper, ...wrapperClasses, hasOverflowClass, listSizeClass, spacingBetweenClass)} style={{ ...wrapperStyles, ...splitStyles }} id={identifier}>
            <div className={combineClasses(styles.container, ...splitClasses)}>
                {props.content.gallery && props.content.gallery.length > 0 ? (
                    <div className={styles.list}>
                        {props.content.gallery.map((media, index) => {
                            if (media.content._contentType === "nestedGalleryImage") {
                                return (
                                    <Image className={styles.item} mediaCrop={props.settings.mediaCrop} {...media} key={index} />
                                );
                            }
                            else if (media.content._contentType === "nestedGalleryVideo") {
                                return (
                                    <Video className={styles.item} mediaCrop={props.settings.mediaCrop} {...media} key={index} />
                                );
                            }
                        })}
                    </div>
                ) : null}
            </div>

            {props.settings.backgroundMedia?.[0] && props.settings.backgroundMedia.length > 0 ? (
                <BackgroundMedia key={props.contentUdi} {...props.settings.backgroundMedia[0]} />
            ) : null}
        </section>
    );
};

export default Gallery;